import {
  type SearchEndpointArgs,
  type SearchResult,
  useInfiniteScroll,
  useLazyGetSearchResultsQuery,
} from '@carboncopyco/data';
import { useEffect, useMemo, useState } from 'react';
import { SearchDropdown } from '../../../SearchDropdown';
import { useDashboardProps } from '../../DashboardContext';
import { useTableProps } from '../../DemoDashboard/SessionBreakdownTables/TableContext';
import { useFilterLogic } from './useFilterLogic';

export const DemosFilter = () => {
  const { organizationId } = useDashboardProps();
  const { demos, setDemos } = useTableProps();
  const [query, setQuery] = useState('');

  const fetchArgs: SearchEndpointArgs = useMemo(
    () => ({
      organizationId,
      entities: ['demo'],
      query,
      includeArchivedWorkspaces: true,
      deletedEntities: 'include_all',
      allOrgWorkspaces: true,
    }),
    [query, organizationId]
  );

  const {
    items: data,
    isLoading,
    isLoadingBatch,
    fetchFirstBatch,
    fetchNextBatch,
    isEmpty,
  } = useInfiniteScroll<SearchResult>(useLazyGetSearchResultsQuery);

  useEffect(() => {
    fetchFirstBatch(fetchArgs);
  }, [fetchArgs]);

  const [items, onChange] = useFilterLogic({
    data,
    selectedItems: demos,
    id: 'id',
    label: 'demoName',
    setter: setDemos,
  });

  return (
    <SearchDropdown
      placeholder="Demo name"
      capsuleWidth={208}
      contentWidth={208}
      searchableItems={items}
      selectedItems={demos}
      onChange={onChange}
      onClear={() => {
        setDemos({});
        setQuery('');
      }}
      query={query}
      setQuery={setQuery}
      onInputChange={() => fetchFirstBatch(fetchArgs)}
      fetchNextBatch={() => fetchNextBatch(fetchArgs)}
      isLoading={isLoading}
      isLoadingBatch={isLoadingBatch}
      disabled={isEmpty}
    />
  );
};
